import * as React from "react";
const SvgFiRrShieldExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shield-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M12 15a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1m.793 8.76C14.953 22.892 22 19.479 22 12.043V6.872a4.99 4.99 0 0 0-3.426-4.746L12.315.05a1 1 0 0 0-.63 0L5.426 2.126A4.99 4.99 0 0 0 2 6.872v5.17c0 6.563 7.005 10.577 9.153 11.65q.409.195.847.308.408-.084.793-.24m5.151-19.736A3 3 0 0 1 20 6.872v5.17c0 6.184-6.087 9.112-7.953 9.862C10.159 20.96 4 17.459 4 12.043V6.872a3 3 0 0 1 2.056-2.848L12 2.054zM12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shield-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShieldExclamation;
